// Экшен для авторизации/регистрации по номеру телефона
import superagent from '@ott/superagent';

import { getBasicUserInfo } from '../getBasicUserInfo';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { Payload } from './types';
import { authByPin } from '../authByPin';
import { AuthError, SuperagentError } from '../../types';
import { ERROR_CODES, STATUS_CODES } from '../../../../constants';
import { successEvent, wrongPinEvent } from '../../helpers/events';

export const enterByPhone = createAsyncThunk<void, Payload, { rejectValue: AuthError }>(
  'auth/enterByPhone/fetch',
  async ({ phone, pin, reqHost = '' }, { dispatch }) => {
    dispatch(authByPin.pending('', { phone, pin, reqHost }));
    const url = `${reqHost}/_auth/authenticate/by-phone`;
    try {
      const {
        body: { result },
      } = await superagent
        .post(url, { captchaMountContainer: 'enter-by-phone' })
        .type('form')
        .send({ phone, pin })
        .withCredentials();

      successEvent('AuthByCardIssue_Popup_Phone_Result');

      if (result === 'OK') {
        dispatch(authByPin.fulfilled(undefined, '', { phone, pin, reqHost }));
      }

      await dispatch(getBasicUserInfo({ reqHost }));

      return;
    } catch (e) {
      const err = e as SuperagentError;

      if ('response' in err) {
        const { error } = err.response.body ?? {};
        switch (err.status) {
          case STATUS_CODES.UNAUTHORIZED:
            if (error === ERROR_CODES.PIN_EXPIRED || error === ERROR_CODES.INVALID_PIN) {
              wrongPinEvent('AuthByCardIssue_Popup_Phone_Result');

              dispatch(authByPin.rejected(null, '', { phone, pin, reqHost }, { data: error }));
              return;
            }
            break;
          case STATUS_CODES.BAD_REQUEST:
            if (error === ERROR_CODES.INVALID_PIN_PARAM) {
              dispatch(authByPin.rejected(null, '', { phone, pin, reqHost }, { data: error }));
              return;
            }
            break;
        }
      }
    }
  }
);
